// import React, {useRef, useState} from 'react';
// import {InputTextarea} from "primereact/inputtextarea";
// import {Button} from "primereact/button";
// import {Card} from "primereact/card";
// import {InputText} from "primereact/inputtext";
// import {FileUpload} from "primereact/fileupload";
// import {InputSwitch} from "primereact/inputswitch";
// import {Toast} from "primereact/toast";
// import TextEditor from "../../components/TextEditor";
//
// const NoticeboardCreate = () => {
//     const toast = useRef<any>(null);
//     const [formData, setFormData] = useState({
//         title: "",
//         content: "",
//         status: true,
//         metaTitle: "",
//         metaDescription: "",
//         keywords: "",
//         featuredImage: null,
//         referenceDocuments: ""
//     });
//
//     const onUploadPdf = (event: any) => {
//         setFormData({
//             ...formData,
//             referenceDocuments: event.files[0],
//         })
//     };
//     const onRemovePdf = () => {
//         setFormData({
//             ...formData,
//             referenceDocuments: "",
//         })
//     };
//     const onUpload = (event: any) => {
//         setFormData({
//             ...formData,
//             featuredImage: event.files[0],
//         })
//     };
//     const onRemove = () => {
//         setFormData({
//             ...formData,
//             featuredImage: null
//         })
//     };
//
//     const handleChange = (e: any) => {
//         setFormData({
//             ...formData,
//             [e.target.name]: e.target.value,
//         })
//     }
//     const header = (
//         <div className="flex align-items-center justify-content-between p-4 pb-0">
//             <h4 className="m-0">Notice Create</h4>
//             <div className="flex align-items-center">
//                 <label htmlFor="">Publish Now</label>
//                 <InputSwitch className="ml-2" name={'status'} checked={formData.status} onChange={handleChange}/>
//             </div>
//         </div>
//     )
//
//     return (
//         <Card header={header}>
//             <Toast ref={toast}/>
//             <div className="grid">
//                 <div className="col-12 md:col-7">
//                     <div className="pr-2">
//                         <div className="my-2">
//                             <label className="font-medium">Title *</label>
//                             <InputText name={'title'} value={formData?.title} className="w-full" onChange={handleChange}  placeholder="Title"/>
//                         </div>
//                         <div className="col-12">
//                             <label className="font-medium">Keywords</label>
//                             <InputText
//                                 name="keywords"
//                                 placeholder="keyword1, keyword2, keyword3"
//                                 className="w-full"
//                                 value={formData.keywords || ""}
//                                 onChange={handleChange}
//                             />
//                         </div>
//                         <div className="col-12">
//                             <label className="font-medium">Thumbnail Image (1024 kB max) *</label>
//                             <FileUpload
//                                 name="demo[]"
//                                 url="/api/upload"
//                                 multiple={false}
//                                 accept="image/*"
//                                 maxFileSize={1024*1024}
//                                 onSelect={onUpload}
//                                 onRemove={onRemove}
//                             />
//                         </div>
//                         <div className="col-12">
//                             <label className="font-medium">Document (10 mb max)</label>
//                             <FileUpload
//                                 name="demo[]"
//                                 url="/api/upload"
//                                 multiple={false}
//                                 accept="application/pdf"
//                                 maxFileSize={10 * 1024 * 1024}
//                                 onSelect={onUploadPdf}
//                                 onRemove={onRemovePdf}
//                             />
//                         </div>
//                         <div>
//                             <label className="font-medium">Details *</label>
//                             <TextEditor
//                                 value={formData.content || ''}
//                                 setValue={(content: string) =>
//                                     setFormData((prev: any) => ({
//                                         ...prev,
//                                         content: content,
//                                     }))
//                                 }
//                             />
//                         </div>
//                     </div>
//                 </div>
//                 <div className="col-12 md:col-5">
//                     <div className="grid p-4">
//                         <div className="col-12">
//                             <h4 className="mb-3">SEO Information</h4>
//                         </div>
//
//                         {/* Meta Title */}
//                         <div className="col-12">
//                             <label className="font-medium">Meta Title</label>
//                             <InputText
//                                 name="metaTitle"
//                                 placeholder="Meta Title"
//                                 className="w-full"
//                                 value={formData.metaTitle}
//                                 onChange={handleChange}
//                             />
//                         </div>
//
//                         {/* Meta Description */}
//                         <div className="col-12">
//                             <label className="font-medium">Meta Description</label>
//                             <InputTextarea
//                                 name="metaDescription"
//                                 rows={4}
//                                 placeholder="Meta Description"
//                                 className="w-full"
//                                 value={formData.metaDescription}
//                                 onChange={handleChange}
//                                 autoResize
//                             />
//                         </div>
//
//                         {/* Meta Keywords */}
//
//
//                     </div>
//                 </div>
//             </div>
//             <div className="col-12 flex justify-content-end gap-2 mt-3">
//                 <Button label="Add Notice" icon="pi pi-check" />
//             </div>
//         </Card>
//     );
// };
//
// export default NoticeboardCreate;

import React, { useRef, useState } from "react";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { FileUpload } from "primereact/fileupload";
import { InputSwitch } from "primereact/inputswitch";
import { Toast } from "primereact/toast";
import TextEditor from "../../components/TextEditor";
import usePost from "../../hooks/usePost";
import { webInfo } from "../../utils/webInfo";
import callToast, { catchError, showErrors } from "../../utils/helper";

const NoticeboardCreate = () => {
    const toast = useRef<any>(null);
    const { post,loading:ploading } = usePost();
    const url = `${webInfo.baseUrl}/api/admin/notice-board`;

    const [formDataState, setFormDataState] = useState<any>({
        title: "",
        content: "",
        status: true,
        meta_title: "",
        meta_description: "",
        meta_keywords: "",
        image: null,
        file: null
    });

    const onUploadPdf = (event: any) => {
        setFormDataState({
            ...formDataState,
            file: event.files[0] || null
        });
    };

    const onRemovePdf = () => {
        setFormDataState({
            ...formDataState,
            file: null
        });
    };

    const onUpload = (event: any) => {
        setFormDataState({
            ...formDataState,
            image: event.files[0] || null
        });
    };

    const onRemove = () => {
        setFormDataState({
            ...formDataState,
            image: null
        });
    };

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        setFormDataState({
            ...formDataState,
            [name]: value
        });
    };

    const handleStatusChange = (value: boolean) => {
        setFormDataState({
            ...formDataState,
            status: value
        });
    };

    const validateForm = () => {
        const errors: any = {};

        if (!formDataState.title || formDataState.title.trim().length === 0) {
            errors.title = ["Title is required"];
        }

        if (!formDataState.content || formDataState.content.trim().length === 0) {
            errors.content = ["Content is required"];
        }

        if (!formDataState.image) {
            errors.image = ["Featured image is required"];
        }

        if (
            formDataState.image &&
            formDataState.image.size > 1024 * 1024
        ) {
            errors.image = ["Featured image must be less than 1 MB"];
        }

        if (
            formDataState.file &&
            formDataState.file.size > 10 * 1024 * 1024
        ) {
            errors.file = ["Document must be less than 10 MB"];
        }

        if (Object.keys(errors).length > 0) {
            showErrors(errors, toast);
            return false;
        }

        return true;
    };

    const addNotice = async () => {
        if (!validateForm()) return;

        const formData = new FormData();

        const payload: any = {
            ...formDataState
        };

        for (const key in payload) {
            const value = payload[key as keyof typeof payload];

            if (value === null || value === undefined) continue;

            if (key === "status") {
                formData.append("status", formDataState?.status ? "1" : "0");
                continue;
            }

            if (typeof value === "number" || typeof value === "boolean") {
                formData.append(key, String(value));
                continue;
            }

            if (typeof value === "string" && value.trim().length === 0) continue;

            if (key === "image" && value instanceof File) {
                formData.append("image", value);
                continue;
            }

            if (key === "file" && value instanceof File) {
                formData.append("file", value);
                continue;
            }

            if (key === "image" && typeof value === "string") continue;
            if (key === "file" && typeof value === "string") continue;

            formData.append(key, String(value));
        }

        try {
            // @ts-ignore
            const res: any = await post(url, false, formData);

            if (res.success) {
                callToast(toast, true, res.data.message || "Notice added successfully");

                setFormDataState({
                    title: "",
                    content: "",
                    status: true,
                    meta_title: "",
                    meta_description: "",
                    meta_keywords: "",
                    image: null,
                    file: null
                });
            } else {
                showErrors(res.error?.errors || res.error, toast);
            }
        } catch (e) {
            catchError(e);
        }
    };

    const header = (
        <div className="flex align-items-center justify-content-between p-4 pb-0">
            <h4 className="m-0">Notice Create</h4>
            <div className="flex align-items-center">
                <label htmlFor="">Publish Now</label>
                <InputSwitch
                    className="ml-2"
                    checked={formDataState.status}
                    onChange={(e) => handleStatusChange(e.value)}
                />
            </div>
        </div>
    );

    return (
        <Card header={header}>
            <Toast ref={toast} />
            <div className="grid">
                <div className="col-12 md:col-7">
                    <div className="pr-2">
                        <div className="my-2">
                            <label className="font-medium">Title *</label>
                            <InputText
                                name="title"
                                value={formDataState.title}
                                className="w-full"
                                onChange={handleChange}
                                placeholder="Title"
                            />
                        </div>

                        <div className="col-12 px-0 mt-3">
                            <label className="font-medium">
                                Thumbnail Image (1024 kB max) *
                            </label>
                            <FileUpload
                                name="file"
                                url="/api/upload"
                                multiple={false}
                                accept="image/*"
                                maxFileSize={1024 * 1024}
                                onSelect={onUpload}
                                onRemove={onRemove}
                            />
                        </div>

                        <div className="col-12 px-0 mt-3">
                            <label className="font-medium">Document (10 mb max)</label>
                            <FileUpload
                                name="file"
                                url="/api/upload"
                                multiple={false}
                                accept="application/pdf"
                                maxFileSize={10 * 1024 * 1024}
                                onSelect={onUploadPdf}
                                onRemove={onRemovePdf}
                            />
                        </div>

                        <div className="mt-3">
                            <label className="font-medium">Details *</label>
                            <TextEditor
                                value={formDataState.content || ""}
                                setValue={(content: string) =>
                                    setFormDataState((prev: any) => ({
                                        ...prev,
                                        content
                                    }))
                                }
                            />
                        </div>
                    </div>
                </div>

                <div className="col-12 md:col-5">
                    <div className="grid p-4">
                        <div className="col-12">
                            <h4 className="mb-3">SEO Information</h4>
                        </div>

                        <div className="col-12">
                            <label className="font-medium">Meta Title</label>
                            <InputText
                                name="meta_title"
                                placeholder="Meta Title"
                                className="w-full"
                                value={formDataState.meta_title}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="col-12 px-0">
                            <label className="font-medium">Meta Keywords</label>
                            <InputText
                                name="meta_keywords"
                                placeholder="keyword1, keyword2, keyword3"
                                className="w-full"
                                value={formDataState.meta_keywords || ""}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label className="font-medium">Meta Description</label>
                            <InputTextarea
                                name="meta_description"
                                rows={4}
                                placeholder="Meta Description"
                                className="w-full"
                                value={formDataState.meta_description}
                                onChange={handleChange}
                                autoResize
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-12 flex justify-content-end gap-2 mt-3">
                <Button
                    label="Add Notice"
                    icon="pi pi-check"
                    loading={ploading}
                    onClick={addNotice}
                    type="button"
                />
            </div>
        </Card>
    );
};

export default NoticeboardCreate;